import { Navigate, useLocation } from "react-router-dom";

const OtpRoute = ({ children }) => {
  const location = useLocation();

  if (!location.state || !location.state.mobile) {
    return <Navigate to="/" />;
  }

  return children;
};

export default OtpRoute;